import "core-js/fn/array/find";
import "core-js/fn/array/includes";
import "core-js/fn/number/is-nan";
import "core-js/fn/string/starts-with";
import "core-js/es6/symbol";
import "core-js/fn/symbol/iterator";
import "core-js/fn/array/find-index";
import "core-js/fn/array/some";
import "core-js/fn/object/assign";
import "core-js/fn/string/ends-with";
import "core-js/fn/promise";
import "core-js/fn/string/includes";
